import classnames from "classnames";
import React, { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
import { NavbarDropdowns, NavbarToggle } from "../../components/Navbar";
import { MESSAGE_ERROR } from "../../config/AppConstant";
import { PATH_DASHBOARD } from "../../routes/constants";
import { showMessage } from "../../utils/app-utils";
import CleanerEgenQuestionnaires from "./CleanerEgenQuestionnaires";
import TeamLeadEgenQuestionnaires from "./TeamLeadEgenQuestionnaires";

const EgenQuestionnaireTabs = (props) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <Container fluid>
      <Header>
        <div className="effektToggle">
          <NavbarToggle />
          <HeaderTitle>{t("egen_questionnaires")}</HeaderTitle>
        </div>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to={PATH_DASHBOARD}>{t("dashboard")}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>{t("egen_questionnaires")}</BreadcrumbItem>
        </Breadcrumb>
        <NavbarDropdowns />
      </Header>
      <div className={"tab "}>
        <Nav style={{ backgroundColor: "#f8f9fa" }} tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                toggle("1");
              }}
            >
              {t("team_lead")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => {
                toggle("2");
              }}
            >
              {t("cleaner")}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <ErrorBoundary
              fallbackRender={() => {}}
              onError={() => {
                showMessage({
                  type: MESSAGE_ERROR,
                  message: t("questionnaires_fallback_msg"),
                });
              }}
            >
              <TeamLeadEgenQuestionnaires />
            </ErrorBoundary>
          </TabPane>
          <TabPane tabId="2">
            <ErrorBoundary
              fallbackRender={() => {}}
              onError={() => {
                showMessage({
                  type: MESSAGE_ERROR,
                  message: t("questionnaires_fallback_msg"),
                });
              }}
            >
              <CleanerEgenQuestionnaires />
            </ErrorBoundary>
          </TabPane>
        </TabContent>
      </div>
    </Container>
  );
};
export default EgenQuestionnaireTabs;
